function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isNumber, isObject } from 'vega-util';
import { getMarkPropOrConfig } from '../compile/common';
import { extractTransformsFromEncoding, normalizeEncoding } from '../encoding';
import * as log from '../log';
import { isMarkDef } from '../mark';
import { isEmpty, omit } from '../util';
import { CompositeMarkNormalizer } from './base';
import { compositeMarkContinuousAxis, compositeMarkOrient, filterTooltipWithAggregatedField, getCompositeMarkTooltip, getTitle, makeCompositeAggregatePartFactory, partLayerMixins } from './common';
export var BOXPLOT = 'boxplot';
export var BOXPLOT_PARTS = ['box', 'median', 'outliers', 'rule', 'ticks'];
export var boxPlotNormalizer = new CompositeMarkNormalizer(BOXPLOT, normalizeBoxPlot);
export function getBoxPlotType(extent) {
  if (isNumber(extent)) {
    return 'tukey';
  } // Ham: If we ever want to, we could add another extent syntax `{kIQR: number}` for the original [Q1-k*IQR, Q3+k*IQR] whisker and call this boxPlotType = `kIQR`. However, I'm not exposing this for now.


  return extent;
}
export function normalizeBoxPlot(spec, _ref) {
  var _markDef$extent;

  var config = _ref.config;
  // Need to initEncoding first so we can infer type
  spec = _objectSpread(_objectSpread({}, spec), {}, {
    encoding: normalizeEncoding(spec.encoding, config)
  });

  var _spec = spec,
      mark = _spec.mark,
      _encoding = _spec.encoding,
      params = _spec.params,
      _p = _spec.projection,
      outerSpec = _objectWithoutProperties(_spec, ["mark", "encoding", "params", "projection"]);

  var markDef = isMarkDef(mark) ? mark : {
    type: mark
  }; // TODO(https://github.com/vega/vega-lite/issues/3702): add selection support

  if (params) {
    log.warn(log.message.selectionNotSupported('boxplot'));
  }

  var extent = (_markDef$extent = markDef.extent) !== null && _markDef$extent !== void 0 ? _markDef$extent : config.boxplot.extent;
  var sizeValue = getMarkPropOrConfig('size', markDef, // TODO: https://github.com/vega/vega-lite/issues/6245
  config);
  var boxPlotType = getBoxPlotType(extent);

  var _boxParams = boxParams(spec, extent, config),
      bins = _boxParams.bins,
      timeUnits = _boxParams.timeUnits,
      transform = _boxParams.transform,
      continuousAxisChannelDef = _boxParams.continuousAxisChannelDef,
      continuousAxis = _boxParams.continuousAxis,
      groupby = _boxParams.groupby,
      aggregate = _boxParams.aggregate,
      encodingWithoutContinuousAxis = _boxParams.encodingWithoutContinuousAxis,
      ticksOrient = _boxParams.ticksOrient,
      boxOrient = _boxParams.boxOrient,
      customTooltipWithoutAggregatedField = _boxParams.customTooltipWithoutAggregatedField;

  var color = encodingWithoutContinuousAxis.color,
      size = encodingWithoutContinuousAxis.size,
      encodingWithoutSizeColorAndContinuousAxis = _objectWithoutProperties(encodingWithoutContinuousAxis, ["color", "size"]);

  var makeBoxPlotPart = function makeBoxPlotPart(sharedEncoding) {
    return makeCompositeAggregatePartFactory(markDef, continuousAxis, continuousAxisChannelDef, sharedEncoding, config.boxplot);
  };

  var makeBoxPlotExtent = makeBoxPlotPart(encodingWithoutSizeColorAndContinuousAxis);
  var makeBoxPlotBox = makeBoxPlotPart(encodingWithoutContinuousAxis);
  var makeBoxPlotMidTick = makeBoxPlotPart(_objectSpread(_objectSpread({}, encodingWithoutSizeColorAndContinuousAxis), size ? {
    size: size
  } : {}));
  var fiveSummaryTooltipEncoding = getCompositeMarkTooltip([{
    fieldPrefix: boxPlotType === 'min-max' ? 'upper_whisker_' : 'max_',
    titlePrefix: 'Max'
  }, {
    fieldPrefix: 'upper_box_',
    titlePrefix: 'Q3'
  }, {
    fieldPrefix: 'mid_box_',
    titlePrefix: 'Median'
  }, {
    fieldPrefix: 'lower_box_',
    titlePrefix: 'Q1'
  }, {
    fieldPrefix: boxPlotType === 'min-max' ? 'lower_whisker_' : 'min_',
    titlePrefix: 'Min'
  }], continuousAxisChannelDef, encodingWithoutContinuousAxis); // ## Whisker Layers

  var endTick = {
    type: 'tick',
    color: 'black',
    opacity: 1,
    orient: ticksOrient,
    invalid: null,
    aria: false
  };
  var whiskerTooltipEncoding = boxPlotType === 'min-max' ? fiveSummaryTooltipEncoding // for min-max, show five-summary tooltip for whisker
  : // for tukey / k-IQR, just show upper/lower-whisker
  getCompositeMarkTooltip([{
    fieldPrefix: 'upper_whisker_',
    titlePrefix: 'Upper Whisker'
  }, {
    fieldPrefix: 'lower_whisker_',
    titlePrefix: 'Lower Whisker'
  }], continuousAxisChannelDef, encodingWithoutContinuousAxis);
  var whiskerLayers = [].concat(_toConsumableArray(makeBoxPlotExtent({
    partName: 'rule',
    mark: {
      type: 'rule',
      invalid: null,
      aria: false
    },
    positionPrefix: 'lower_whisker',
    endPositionPrefix: 'lower_box',
    extraEncoding: whiskerTooltipEncoding
  })), _toConsumableArray(makeBoxPlotExtent({
    partName: 'rule',
    mark: {
      type: 'rule',
      invalid: null,
      aria: false
    },
    positionPrefix: 'upper_box',
    endPositionPrefix: 'upper_whisker',
    extraEncoding: whiskerTooltipEncoding
  })), _toConsumableArray(makeBoxPlotExtent({
    partName: 'ticks',
    mark: endTick,
    positionPrefix: 'lower_whisker',
    extraEncoding: whiskerTooltipEncoding
  })), _toConsumableArray(makeBoxPlotExtent({
    partName: 'ticks',
    mark: endTick,
    positionPrefix: 'upper_whisker',
    extraEncoding: whiskerTooltipEncoding
  }))); // ## Box Layers
  // TODO: support hiding certain mark parts

  var boxLayers = [].concat(_toConsumableArray(boxPlotType !== 'tukey' ? whiskerLayers : []), _toConsumableArray(makeBoxPlotBox({
    partName: 'box',
    mark: _objectSpread(_objectSpread({
      type: 'bar'
    }, sizeValue ? {
      size: sizeValue
    } : {}), {}, {
      orient: boxOrient,
      invalid: null,
      ariaRoleDescription: 'box'
    }),
    positionPrefix: 'lower_box',
    endPositionPrefix: 'upper_box',
    extraEncoding: fiveSummaryTooltipEncoding
  })), _toConsumableArray(makeBoxPlotMidTick({
    partName: 'median',
    mark: _objectSpread(_objectSpread(_objectSpread({
      type: 'tick',
      invalid: null
    }, isObject(config.boxplot.median) && config.boxplot.median.color ? {
      color: config.boxplot.median.color
    } : {}), sizeValue ? {
      size: sizeValue
    } : {}), {}, {
      orient: ticksOrient,
      aria: false
    }),
    positionPrefix: 'mid_box',
    extraEncoding: fiveSummaryTooltipEncoding
  })));

  if (boxPlotType === 'min-max') {
    var _outerSpec$transform;

    return _objectSpread(_objectSpread({}, outerSpec), {}, {
      transform: ((_outerSpec$transform = outerSpec.transform) !== null && _outerSpec$transform !== void 0 ? _outerSpec$transform : []).concat(transform),
      layer: boxLayers
    });
  } // Tukey Box Plot


  var lowerBoxExpr = "datum[\"lower_box_".concat(continuousAxisChannelDef.field, "\"]");
  var upperBoxExpr = "datum[\"upper_box_".concat(continuousAxisChannelDef.field, "\"]");
  var iqrExpr = "(".concat(upperBoxExpr, " - ").concat(lowerBoxExpr, ")");
  var lowerWhiskerExpr = "".concat(lowerBoxExpr, " - ").concat(extent, " * ").concat(iqrExpr);
  var upperWhiskerExpr = "".concat(upperBoxExpr, " + ").concat(extent, " * ").concat(iqrExpr);
  var fieldExpr = "datum[\"".concat(continuousAxisChannelDef.field, "\"]");
  var joinaggregateTransform = {
    joinaggregate: boxParamsQuartiles(continuousAxisChannelDef.field),
    groupby: groupby
  };
  var filteredWhiskerSpec = {
    transform: [{
      filter: "(".concat(lowerWhiskerExpr, " <= ").concat(fieldExpr, ") && (").concat(fieldExpr, " <= ").concat(upperWhiskerExpr, ")")
    }, {
      aggregate: [{
        op: 'min',
        field: continuousAxisChannelDef.field,
        as: "lower_whisker_".concat(continuousAxisChannelDef.field)
      }, {
        op: 'max',
        field: continuousAxisChannelDef.field,
        as: "upper_whisker_".concat(continuousAxisChannelDef.field)
      }, // preserve lower_box / upper_box
      {
        op: 'min',
        field: "lower_box_".concat(continuousAxisChannelDef.field),
        as: "lower_box_".concat(continuousAxisChannelDef.field)
      }, {
        op: 'max',
        field: "upper_box_".concat(continuousAxisChannelDef.field),
        as: "upper_box_".concat(continuousAxisChannelDef.field)
      }].concat(_toConsumableArray(aggregate)),
      groupby: groupby
    }],
    layer: whiskerLayers
  };

  var tooltip = encodingWithoutSizeColorAndContinuousAxis.tooltip,
      encodingWithoutSizeColorContinuousAxisAndTooltip = _objectWithoutProperties(encodingWithoutSizeColorAndContinuousAxis, ["tooltip"]);

  var scale = continuousAxisChannelDef.scale,
      axis = continuousAxisChannelDef.axis;
  var title = getTitle(continuousAxisChannelDef);
  var axisWithoutTitle = omit(axis, ['title']);
  var outlierLayersMixins = partLayerMixins(markDef, 'outliers', config.boxplot, {
    transform: [{
      filter: "(".concat(fieldExpr, " < ").concat(lowerWhiskerExpr, ") || (").concat(fieldExpr, " > ").concat(upperWhiskerExpr, ")")
    }],
    mark: 'point',
    encoding: _objectSpread(_objectSpread(_objectSpread(_defineProperty({}, continuousAxis, _objectSpread(_objectSpread(_objectSpread({
      field: continuousAxisChannelDef.field,
      type: continuousAxisChannelDef.type
    }, title !== undefined ? {
      title: title
    } : {}), scale !== undefined ? {
      scale: scale
    } : {}), isEmpty(axisWithoutTitle) ? {} : {
      axis: axisWithoutTitle
    })), encodingWithoutSizeColorContinuousAxisAndTooltip), color ? {
      color: color
    } : {}), customTooltipWithoutAggregatedField ? {
      tooltip: customTooltipWithoutAggregatedField
    } : {})
  })[0];
  var filteredLayersMixins;
  var filteredLayersMixinsTransforms = [].concat(_toConsumableArray(bins), _toConsumableArray(timeUnits), [joinaggregateTransform]);

  if (outlierLayersMixins) {
    filteredLayersMixins = {
      transform: filteredLayersMixinsTransforms,
      layer: [outlierLayersMixins, filteredWhiskerSpec]
    };
  } else {
    var _filteredLayersMixins;

    filteredLayersMixins = filteredWhiskerSpec;

    (_filteredLayersMixins = filteredLayersMixins.transform).unshift.apply(_filteredLayersMixins, _toConsumableArray(filteredLayersMixinsTransforms));
  }

  return _objectSpread(_objectSpread({}, outerSpec), {}, {
    layer: [filteredLayersMixins, {
      // boxplot
      transform: transform,
      layer: boxLayers
    }]
  });
}

function boxParamsQuartiles(continousAxisField) {
  return [{
    op: 'q1',
    field: continousAxisField,
    as: "lower_box_".concat(continousAxisField)
  }, {
    op: 'q3',
    field: continousAxisField,
    as: "upper_box_".concat(continousAxisField)
  }];
}

function boxParams(spec, extent, config) {
  var orient = compositeMarkOrient(spec, BOXPLOT);

  var _compositeMarkContinu = compositeMarkContinuousAxis(spec, orient, BOXPLOT),
      continuousAxisChannelDef = _compositeMarkContinu.continuousAxisChannelDef,
      continuousAxis = _compositeMarkContinu.continuousAxis;

  var continuousFieldName = continuousAxisChannelDef.field;
  var boxPlotType = getBoxPlotType(extent);
  var boxplotSpecificAggregate = [].concat(_toConsumableArray(boxParamsQuartiles(continuousFieldName)), [{
    op: 'median',
    field: continuousFieldName,
    as: "mid_box_".concat(continuousFieldName)
  }, {
    op: 'min',
    field: continuousFieldName,
    as: (boxPlotType === 'min-max' ? 'lower_whisker_' : 'min_') + continuousFieldName
  }, {
    op: 'max',
    field: continuousFieldName,
    as: (boxPlotType === 'min-max' ? 'upper_whisker_' : 'max_') + continuousFieldName
  }]);
  var postAggregateCalculates = boxPlotType === 'min-max' || boxPlotType === 'tukey' ? [] : [// This is for the  original k-IQR, which we do not expose
  {
    calculate: "datum[\"upper_box_".concat(continuousFieldName, "\"] - datum[\"lower_box_").concat(continuousFieldName, "\"]"),
    as: "iqr_".concat(continuousFieldName)
  }, {
    calculate: "min(datum[\"upper_box_".concat(continuousFieldName, "\"] + datum[\"iqr_").concat(continuousFieldName, "\"] * ").concat(extent, ", datum[\"max_").concat(continuousFieldName, "\"])"),
    as: "upper_whisker_".concat(continuousFieldName)
  }, {
    calculate: "max(datum[\"lower_box_".concat(continuousFieldName, "\"] - datum[\"iqr_").concat(continuousFieldName, "\"] * ").concat(extent, ", datum[\"min_").concat(continuousFieldName, "\"])"),
    as: "lower_whisker_".concat(continuousFieldName)
  }];

  var _spec$encoding = spec.encoding,
      oldContinuousAxisChannelDef = _spec$encoding[continuousAxis],
      oldEncodingWithoutContinuousAxis = _objectWithoutProperties(_spec$encoding, [continuousAxis].map(_toPropertyKey));

  var _filterTooltipWithAgg = filterTooltipWithAggregatedField(oldEncodingWithoutContinuousAxis),
      customTooltipWithoutAggregatedField = _filterTooltipWithAgg.customTooltipWithoutAggregatedField,
      filteredEncoding = _filterTooltipWithAgg.filteredEncoding;

  var _extractTransformsFro = extractTransformsFromEncoding(filteredEncoding, config),
      bins = _extractTransformsFro.bins,
      timeUnits = _extractTransformsFro.timeUnits,
      aggregate = _extractTransformsFro.aggregate,
      groupby = _extractTransformsFro.groupby,
      encodingWithoutContinuousAxis = _extractTransformsFro.encoding;

  var ticksOrient = orient === 'vertical' ? 'horizontal' : 'vertical';
  var boxOrient = orient;
  var transform = [].concat(_toConsumableArray(bins), _toConsumableArray(timeUnits), [{
    aggregate: [].concat(_toConsumableArray(aggregate), _toConsumableArray(boxplotSpecificAggregate)),
    groupby: groupby
  }], postAggregateCalculates);
  return {
    bins: bins,
    timeUnits: timeUnits,
    transform: transform,
    groupby: groupby,
    aggregate: aggregate,
    continuousAxisChannelDef: continuousAxisChannelDef,
    continuousAxis: continuousAxis,
    encodingWithoutContinuousAxis: encodingWithoutContinuousAxis,
    ticksOrient: ticksOrient,
    boxOrient: boxOrient,
    customTooltipWithoutAggregatedField: customTooltipWithoutAggregatedField
  };
}